import { render } from "./SettingVerification.vue?vue&type=template&id=01809b3d"
import script from "./SettingVerification.vue?vue&type=script&lang=js"
export * from "./SettingVerification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__